export const formHelper = {
    isPublishable,
    
}


function isPublishable(formElements) {

    var result = true;
    var message = [];
    if (!formElements.find(el => { return el.type === 2 && el.props.name === 'FirstName' })) {
        result = false;
        message.push("TheFieldFirstNameIsRequiredForRunningTheForm");
    }
    if (!formElements.find(el => { return el.type === 2 && el.props.name === 'Email' })) {
        result = false;
        message.push("TheFieldEmailIsRequiredForRunningTheForm");
    }
    if (!formElements.find(el => { return el.type === 2 && el.props.name === 'LastName' })) {
        result = false;
        message.push("TheFieldLastNameIsRequiredForRunningTheForm");
    }

    return { result, message };
}
